import {Component, Input} from '@angular/core';
import {Unwetter} from '../../../../model/unwetter/unwetter';

@Component({
  selector: 'app-unwetter-detail',
  templateUrl: './unwetter-detail.component.html',
  styleUrls: ['./unwetter-detail.component.css']
})
export class UnwetterDetailComponent {

  @Input() unwetterVorhersage: Unwetter;
  @Input() isLandKreis: boolean = false;

  getClassByStufe(stufe: number) {
    switch (stufe) {
      case 1:
        return 'warn-header-stufe1';
      case 2:
        return 'warn-header-stufe2';
      case 3:
        return 'warn-header-stufe3';
      case 4:
        return 'warn-header-stufe4';
      default:
        return 'no-warning-header';
    }
  }

}
